import { useContext, useEffect, useMemo, useState } from "react";
import { doc, getDoc } from "firebase/firestore";

import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { LanguageContext } from "../context/LanguageContext";
import LeftMenu from "./menus/LeftMenu";
import HeaderBar from "./headers/HeaderBar";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";
export default function TicketInsights() {
  const { translate } = useContext(LanguageContext);
  const { currentUser } = useAuth();
  const [role, setRole] = useState("Normal User");
  const navigate = useNavigate();
  const [currentUserProfile, setCurrentUserProfile] = useState(null);
  const { projectId: urlProjectId, ticketId: urlTicketId } = useParams();
  useEffect(() => {
    if (!currentUser) return;

    const profileRef = doc(db, "profilsUsers", currentUser.uid);
    getDoc(profileRef)
      .then((docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          setRole(data.role || "Normal User");
          setCurrentUserProfile(data); // ← stocke tout le profil
        } else {
          setRole("Normal User");
        }
      })
      .catch((error) => {
        console.error("Error fetching profile: ", error);
        setRole("Normal User");
      });
  }, [currentUser]);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        backgroundColor: "#f4f8f9",
      }}
    >
      <LeftMenu />
      <div
        style={{
          width: "90%",
          boxSizing: "border-box",
          marginLeft: "5px",
          // backgroundColor: "white",
        }}
      >
        <HeaderBar
          title={translate("SupportTickets")}
          subtitle={translate("PleaseSendTicket")}
          showProjectSelect={false}
          userName={currentUser.displayName}
          userRole={role}
        ></HeaderBar>

        {/* === Nos nouveaux onglets de statut === */}
        {/* === Nos nouveaux onglets de statut === */}
        <div
          style={{
            paddingLeft: "20px",
            display: "flex",
            flexDirection: "column",
            height: "80%",
          }}
        >
          <Box
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "60vh",
            }}
          >
            <Card
              sx={{ p: 4, borderRadius: 2, boxShadow: 3, textAlign: "center" }}
            >
              <CardContent>
                <Typography variant="h5" gutterBottom>
                  {translate("AvailableOnPremium")}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ mb: 3 }}
                >
                  {translate("DetailAvailableOnPremium")}
                </Typography>
                <Button
                  variant="contained"
                  onClick={() => navigate("/app/gotopremium")}
                >
                  {translate("GoPremium")}
                </Button>
              </CardContent>
            </Card>
          </Box>
        </div>
      </div>
    </div>
  );
}
